import { motion } from 'framer-motion';
import { useState } from 'react';
import { useInterval } from 'react-use';

// A random percentage between 0%-100% with little variation between each item to simulate a chart loading
function deriveRandomHeights() {
  return Array.from({ length: 18 }, (_, i) => i).map(() => Math.floor(Math.random() * 100));
}

export function NetWorthChartSkeleton() {
  const [heights, setHeights] = useState<number[]>(deriveRandomHeights());

  useInterval(() => {
    setHeights(deriveRandomHeights());
  }, 1500);

  return (
    <div>
      <div className="animate-pulse bg-palette-600/10 rounded-lg w-[300px] h-[30px] mb-1" />
      <div className="animate-pulse bg-darkMode-gray-light/20 rounded-lg w-[270px] h-6" />
      <div className="grid-flow-col grid gap-1 items-end mt-8 mr-10 mb-[40px] h-[304px] w-[434px] pb-[54px] pr-[54px]">
        {heights.map((height, idx) => (
          <motion.div
            key={idx}
            initial={{ height: 0 }}
            animate={{ height: `${height}%` }}
            className="animate-pulse bg-darkMode-gray-medium/20 w-[14.5px] h-full rounded-full min-h-[15px]"
          />
        ))}
      </div>
    </div>
  );
}
